import React, { useState, useEffect, useRef } from "react";
import { Form, Button } from "react-bootstrap";
import CompProfileTabs from "./CompProfileTabs";
import "./CompProfile.css";
import GenericOverviewSideCard from "../genericComponents/GenericOverviewSideCard";
import * as FeatherIcon from "react-feather";
import { Link } from "react-router-dom";
import { useUser } from "../../../context/UserContext";
import AIChat from "../Chat/AiChat";
import { useParams } from "react-router-dom";
import iq_download from "../../../services/iqDownload";
import api from "../../../services/api";
import { exportRequest } from "../../../services/accIqService";
import { useWebSocket } from "../uiUtils/useWebSocket";
import ProgressOverlay from "../../HtmlElements/ProgressOverlay";
import { API_BASE_URL } from "../../../config/apiConfig";
import useAuth from "../../../hooks/useAuth";

export default function CompProfile() {
  useAuth();
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [showAiInsights, setShowAiInsights] = useState(false);
  const [activeParentTabKey, setParentActiveTab] = useState("executiveSnap");
  const [compView, setCompetitorView] = useState("complete");
  const wsRef = useRef(null);
  const [wsUrl, setWsUrl] = useState(null);
  const tabTypeMap = {
    executiveSnap: "Executive Snapshot",
    profileMarketPosition: "Market Position & Customer Intelligence",
    profileProductInnovation: "Product & Innovation",
    financials: "Financial Performance & Strategy",
    marketing: "Marketing & Distribution",
    operations: "Operations & Supply Chain",
    orgStructure: "Corporate & Organizational Structure",
    news: "News",
  };

  const { user } = useUser();
  const { clientName, competitorName } = useParams();
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const POLLING_INTERVAL_MS = 5000; // 5 sec
  // const POLLING_INTERVAL_MS = 600000; // 10 minutes

  // +++++++++++++++++++++++++++++++
  const [showProgress, setShowProgress] = useState(false);
  const [taskCompleted, setTaskCompleted] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setTaskCompleted(true), 480000);
    return () => clearTimeout(timer);
  }, []);
  // +++++++++++++++++++++++++++++++

  const downloadFileAsBlob = async (taskId, filename, downloadUrl) => {
    try {
      // const resp = await iq_download.get(`api/pdf/downloads/${taskId}.pdf`, {
      //   responseType: "blob",
      // });
      const resp = await iq_download.get(`${downloadUrl}`, {
        responseType: "blob",
      });

      // Check if response status is OK
      if (!resp.status || resp.status !== 200) {
        throw new Error(`Download failed: ${resp.status} ${resp.statusText}`);
      }

      const blob = resp.data;
      const objectUrl = URL.createObjectURL(blob);

      const timestamp = new Date().toISOString().replace(/[^\w]/g, "_");
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = `Competitor Profile For ${competitorName}_${timestamp}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(objectUrl);
      setTaskCompleted(false);
      setShowProgress(false);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  // const pollTaskStatus = async (taskId) => {
  //   setStatus("Polling export status...");
  //   setShowProgress(true);
  //   const intervalId = setInterval(async () => {
  //     try {
  //       const res = await iq_download.get(`/api/pdf/export-status/${taskId}`);

  //       if (!res) {
  //         setStatus(`Error: ${res.status} ${res.statusText}`);
  //         clearInterval(intervalId);
  //         return;
  //       }

  //       // const data = await res.json();
  //       const data = res.data;
  //       console.log("Polling status:", data);
  //       setStatus(`Current status: ${data.status}`);

  //       if (data?.status === "COMPLETE" && data?.pdf_url) {
  //         clearInterval(intervalId);
  //         setStatus("Export complete! Downloading PDF...");

  //         const downloadUrl = `${data.pdf_url}`;
  //         // console.log("COM URL: " + downloadUrl);
  //         const filename = data.pdf_url.split("/").pop();

  //         try {
  //           await downloadFileAsBlob(taskId, filename);
  //           setStatus("Download started (check your downloads folder).");
  //         } catch (err) {
  //           console.error("Download error:", err);
  //           setStatus("Download failed.");
  //         }
  //       } else if (data.status === "FAILED") {
  //         clearInterval(intervalId);
  //         setStatus("Export task failed.");
  //         console.error("Task failed:", data);
  //       }
  //     } catch (err) {
  //       console.error("Polling error:", err);
  //       setStatus("Polling connection failed.");
  //       clearInterval(intervalId);
  //     }
  //   }, POLLING_INTERVAL_MS);
  // };

  const pollTaskStatus = async (taskId, userId, projectId) => {
    let isUserActive = true;
    let intervalId = null;

    // Track user activity / tab visibility
    const handleVisibilityChange = () => {
      isUserActive = !document.hidden;
    };

    // const handleBeforeUnload = () => {
    //   isUserActive = false;
    //   // Optional: tell backend user left
    //   navigator.sendBeacon(
    //     "/api/user_inactive",
    //     JSON.stringify({ userId, projectId })
    //   );
    // };

    const handleBeforeUnload = () => {
      isUserActive = false;

      const payload = {
        client_name: clientName,
        competitor_name: competitorName,
        user_id: user?.id,
        pdf_url: `https://growthiq.mnmks.com//growth_iq_download_proxy/api/pdf/${taskId}.pdf`,
        task_id: taskId,
      };

      const blob = new Blob([JSON.stringify(payload)], {
        type: "application/json",
      });

      // Use the absolute backend API URL (bypassing interceptors)
      navigator.sendBeacon(`${API_BASE_URL}/export/email_download_link`, blob);
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("beforeunload", handleBeforeUnload);

    setStatus("Polling export status...");
    setShowProgress(true);

    intervalId = setInterval(async () => {
      try {
        const res = await iq_download.get(`/api/pdf/export-status/${taskId}`);
        if (!res) {
          setStatus(`Error: ${res.status} ${res.statusText}`);
          clearInterval(intervalId);
          return;
        }

        const data = res.data;
        console.log("Polling status:", data);
        setStatus(`Current status: ${data.status}`);

        if (data?.status === "COMPLETE" && data?.pdf_url) {
          clearInterval(intervalId);
          document.removeEventListener(
            "visibilitychange",
            handleVisibilityChange
          );
          window.removeEventListener("beforeunload", handleBeforeUnload);

          // const downloadUrl = `https://growthiq.mnmks.com//growth_iq_download_proxy${data.pdf_url}`;
          const downloadUrl = data.pdf_url;
          const filename = data.pdf_url.split("/").pop();
          if (isUserActive) {
            // User still here → download file
            setStatus("Export complete! Downloading PDF...");
            try {
              await downloadFileAsBlob(taskId, filename, downloadUrl);
              setStatus("Download started (check your downloads folder).");
            } catch (err) {
              console.error("Download error:", err);
              setStatus("Download failed.");
            }
          } else {
            // User left → send email
            console.log("User inactive — sending email...");
            setStatus("User left, sending download link to email...");
            await api.post(`/export/email_download_link`, {
              client_name: clientName,
              competitor_name: competitorName,
              user_id: user?.id,
              pdf_url: downloadUrl,
              task_id: taskId,
            });
          }
        } else if (data.status === "FAILED") {
          clearInterval(intervalId);
          setStatus("Export task failed.");
          console.error("Task failed:", data);
        }
      } catch (err) {
        console.error("Polling error:", err);
        setStatus("Polling connection failed.");
        clearInterval(intervalId);
      }
    }, POLLING_INTERVAL_MS);
  };

  const exportAll = async () => {
    const downloadRequestData = {
      client: clientName,
      competitor: competitorName,
    };
    try {
      const res = await exportRequest(downloadRequestData);
      // console.log("Download request response:", res);
      const taskId = res?.task_id;

      if (!taskId) {
        setStatus("Failed: No task_id returned from export API.");
        setLoading(false);
        return;
      }

      setStatus(`Export task started (Task ID: ${taskId})`);
      // Start polling the status
      await pollTaskStatus(taskId);
    } catch (err) {
      console.error("Export request error:", err);
      setStatus("Export request failed.");
    } finally {
      setLoading(false);
    }
  };

  //  Cleanup WebSocket when component unmounts
  useEffect(() => {
    return () => {
      if (wsRef.current) wsRef.current.close();
    };
  }, []);

  const handleCompViewChange = (competitorView = "complete") => {
    setCompetitorView(competitorView);
  };

  return (
    <div>
      {/* ++++++++++++++++++++++++++ */}
      {/* 20 * 60 * 1000 => 20 minutes */}
      {showProgress && (
        <ProgressOverlay
          title="Processing your export"
          linkText={`Competitor profile for ${competitorName}`}
          totalTime={10 * 60 * 1000}
          taskCompleted={taskCompleted}
          onClose={() => setShowProgress(false)}
        />
      )}
      {/* ++++++++++++++++++++++++++ */}
      <div className="account_details_wrapper">
        <div className="cardinal_wrapper">
          <div className="back_to_block mb-4">
            <Link to="/clients_competitors" className="back_to_text_comp">
              <FeatherIcon.ArrowLeft className="back_icon" /> Back to
              Competitors
            </Link>
          </div>
          <div className="cardinal_head_block">
            <div className="cardinal_subblock">
              <h5 className="cardinal_head">
                Competitor Profile – {competitorName}
              </h5>
            </div>

            <div className="cardinal_btns">
              {/* <div className="toggle_list_tableview">
                <Link
                  className={`table_view ${
                    compView === "complete" ? "active" : ""
                  }`}
                  style={{
                    fontSize: "12px",
                    lineHeight: "15px",
                    textDecoration: "none",
                    padding: "7px 12px 7px 12px",
                    // width: "56px",
                    // height: "27px",
                    radius: "8px",
                  }}
                  onClick={() => handleCompViewChange("complete")}
                >
                  Complete
                </Link>
                <Link
                  className={`grid_view ${
                    compView === "quantitative" ? "active" : ""
                  }`}
                  style={{
                    fontSize: "12px",
                    lineHeight: "15px",
                    textDecoration: "none",
                    padding: "7px 12px 7px 12px",
                    // width: "56px",
                    // height: "27px",
                    radius: "8px",
                  }}
                  onClick={() => handleCompViewChange("quantitative")}
                >
                  Quantitative
                </Link>
              </div> */}

              {/* <a href="#" className="cardninal_href">
                New Updates <span className="count_update">15</span>
              </a> */}
              <div className="export-wrapper" style={{ position: "relative" }}>
                <a
                  href="#"
                  className="cardninal_href"
                  onClick={exportAll}
                  disabled={loading}
                >
                  Export{" "}
                  <img
                    src="/img/export_arrow.png"
                    alt="image"
                    className="cardinal_filter_img"
                    width=""
                  />
                </a>
              </div>

              {/* <a href="#" className="cardninal_href">
                Notify My Team{" "}
                <img
                  src="/img/noitfy_my_team.png"
                  alt="image"
                  className="cardinal_filter_img"
                  width=""
                />
              </a> */}
              {/* <a
                href="#"
                className="cardninal_href"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowAiInsights(true);
                }}
              >
                {" "}
                <img
                  src="/img/ai_sparkle.png"
                  alt="image"
                  className="cardinal_filter_img mr-1"
                  width=""
                />{" "}
                AI Insight
              </a> */}
            </div>
          </div>
        </div>
        <div className="top_tabs_custom">
          <CompProfileTabs
            activeParentTabKey={activeParentTabKey}
            setParentActiveTab={setParentActiveTab}
            compView={compView}
          />
        </div>
      </div>

      <GenericOverviewSideCard
        showMoreModal={showMoreModal}
        setShowMoreModal={setShowMoreModal}
        titleForSideCard={"Comp Profile"}
        comp={<></>}
        minWidthForDrawer="50%"
        disableXbtn={true}
      />

      <GenericOverviewSideCard
        showMoreModal={showAiInsights}
        setShowMoreModal={setShowAiInsights}
        titleForSideCard={
          <div className="ai_insight_top_block">
            <div className="ai_insight_left">
              <div className="ai_insight_img">
                <img
                  src="/img/ai_insight_top.png"
                  alt="icon"
                  className="ai_icon"
                />
              </div>
              <div className="ai_insight_text">
                <h5 className="ai_insight_top_head">
                  Decode This: {competitorName}
                  {" - "}
                  {tabTypeMap[activeParentTabKey]}
                </h5>
                <p className="ai_insight_top_subhead">
                  AI-powered competitive intelligence and strategic insights
                </p>
              </div>
            </div>
            <div className="ai_insight_right"></div>
          </div>
        }
        comp={<AIChat />}
        minWidthForDrawer="50%"
        disableXbtn={false}
      />
    </div>
  );
}
